module.exports = __webpack_public_path__ + "static/img/quizze_explore.f81a1994.png";